import { useCallback } from 'react';
import { usePlayerEvent } from './use-player-event';
export const useSegmentSwitched = (player, onChange) => {
  const handleSegmentSwitched = useCallback(event => {
    // TODO: This should be added to event.data.media_urn by Letterbox
    const urn = event?.data?.analyticsMetadata?.media_urn;
    if (onChange && urn) {
      onChange(urn);
    } else if (onChange) {
      // eslint-disable-next-line no-console
      console.warn('Did not get media URN from Letterbox in segmentSwitched event.');
    }
  }, [onChange]);
  usePlayerEvent(player, 'srgssr/segmentSwitched', handleSegmentSwitched);
};